import { useState } from "react";
import { TEnabledDisabledStates } from "../../../../../services/backoffice/backoffice-service";

export type TSubscriptionFilterSettings = {
    name: string;
    enabled: TEnabledDisabledStates;
};

type TSubscriptionFilterPanelProps = {
    filterCallback: (filterSettings: TSubscriptionFilterSettings) => void;
    resetCallback: () => void;
};

export const SubscriptionFilterPanel = (
    props: TSubscriptionFilterPanelProps
) => {
    const { filterCallback, resetCallback } = props;

    const [enabledFilter, setEnableFilter] =
        useState<TEnabledDisabledStates>("all");
    const [searchName, setSearchName] = useState<string>("");

    const applyFilters = () => {
        filterCallback({
            enabled: enabledFilter,
            name: searchName,
        });
    };

    const resetFiltersClickHandler = () => {
        setSearchName("");
        setEnableFilter("all");
        resetCallback();
    };

    return (
        <div className="mb-4 p-3 border rounded shadow-sm bg-light rounded-3">
            <div className="row">
                <div className="col-12 col-md-5 col-lg-4 mb-2 mb-lg-0">
                    <label className="form-label mb-0 fw-bold w-100">
                        Filter by name
                        <input
                            type="text"
                            value={searchName}
                            onChange={(e) => setSearchName(e.target.value)}
                            className="form-control border-dark rounded-3"
                            placeholder="e.g. DentalPro Inc."
                            aria-label="filter by name"
                        />
                    </label>
                </div>
                <div className="col-12 col-md-auto">
                    <label className="form-label mb-0 fw-bold">
                        Is User Blocked?
                        <select
                            className="form-select border-dark rounded-3"
                            value={enabledFilter}
                            onChange={(e) =>
                                setEnableFilter(
                                    e.target.value as TEnabledDisabledStates
                                )
                            }
                        >
                            <option value="all">All Users</option>
                            <option value="enabled">Only Active</option>
                            <option value="disabled">Only Blocked</option>
                        </select>
                    </label>
                </div>
                <div className="col-12 col-md-auto mt-3 mt-lg-auto">
                    <button
                        className="btn btn-primary rounded-3 px-5 me-4"
                        onClick={applyFilters}
                    >
                        <i className="fa-solid fa-magnifying-glass me-2"></i>
                        Search
                    </button>
                    <button
                        className="btn btn-outline-dark rounded-3 px-4"
                        onClick={resetFiltersClickHandler}
                    >
                        Reset
                    </button>
                </div>
            </div>
        </div>
    );
};
